import { transformResponseFromJsonApi } from '@evolve/common-ui';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import {
  Request,
  Response,
  TQueryParams,
  formatQueryParams,
  formatRequest,
  prepareHeaders,
} from 'evolve-ui';

export enum AnadoluCustomerContactStatus {
  POTENTIAL = 1,
  ACTIVE = 2,
  INACTIVE = 3,
  EXCLUDED = 4,
}

export type TAnadoluContact = {
  id?: number;
  name?: string;
  email?: string;
  phone?: string;
  data?: {
    customer?: {
      id?: number;
      name?: string;
      customerStatusId?: number;
      fiscalNumber?: string;
    };
  };
};

export const anadoluContactsApi = createApi({
  reducerPath: 'anadolu-contacts',
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.GATSBY_CUSTOMERS_API_URL}/anadolu/contacts`,
    mode: 'cors',
    prepareHeaders,
  }),
  tagTypes: ['AnadoluContacts'],
  endpoints: (builder) => ({
    getAnadoluContacts: builder.query<Response<TAnadoluContact>, TQueryParams>({
      providesTags: ['AnadoluContacts'],
      query: (params) => formatQueryParams(params),
      transformResponse: transformResponseFromJsonApi<TAnadoluContact>,
    }),

    patchAnadoluContacts: builder.mutation<
      Response<TAnadoluContact>,
      Partial<Pick<TAnadoluContact, 'email' | 'phone'>> & { id: string }
    >({
      invalidatesTags: ['AnadoluContacts'],
      query: ({ id, ...payload }) =>
        formatRequest({ ...payload, type: 'contacts' }, Request.PATCH, id),
      transformResponse: transformResponseFromJsonApi<TAnadoluContact>,
    }),
  }),
});

export const {
  useGetAnadoluContactsQuery,
  usePatchAnadoluContactsMutation,
} = anadoluContactsApi;
